// eslint-disable-next-line eol-last
export const SET_USER = "SET_USER";
export const SET_TOKEN = "SET_TOKEN";
export const LOGOUT = "LOGOUT";
export const SET_USER_DETAIL = "SET_USER_DETAIL";
export const SET_TICKET_TEMPLATE = "SET_TICKET_TEMPLATE";
export const SET_USER_BY_TEAM = "SET_USER_BY_TEAM";
export const SET_TICKET_BY_ID = "SET_TICKET_BY_ID";
export const SET_VIEW_BILL_DETAIL = "SET_VIEW_BILL_DETAIL";
